import React, { useState } from "react";
interface CheckboxProps {
  label: string;
  disabled?: boolean;
  checkboxSelected?: boolean;
  style?: React.CSSProperties;
  customLabelStyle?: React.CSSProperties;
  isStarPresent?: boolean;
  callback: () => void; // Callback prop
}

const EventEHRCheckbox = ({
  label,
  style,
  disabled = false,
  customLabelStyle = {},
  isStarPresent = false,
  callback,
  checkboxSelected = false,
}: CheckboxProps) => {
  const handleChange = () => {
    callback();
  };

  return (
    <div className="space-x-5" style={style}>
      <div className="space-x-2 items-center cursor-pointer flex">
        <div className="w-[24px]">
          <input
            type="checkbox"
            checked={checkboxSelected}
            onChange={() => handleChange()}
            disabled={disabled}
            className="w-[20px] h-[20px] top-[2px] left-[2px] border rounded-md border-[#95929E] accent-[#005596] cursor-pointer"
          />
        </div>
        <div
          className={`font-medium text-[16px] leading-[19.2px] text-[#565656] items-center justify-center text-start bottom-1 relative ${
            disabled ? "opacity-50 cursor-not-allowed" : ""
          }`}
          style={customLabelStyle}
        >
          {label}
          {isStarPresent && (
            <span style={{ color: "#FF0000", marginLeft: "4px" }}>*</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventEHRCheckbox;
